import { NavigationActions } from 'react-navigation';

export function resetNavigation(navigation, args = { routeName: 'Root' }) {
  navigation.reset([NavigationActions.navigate(args)], 0);
}

export function redirectToRoot() {
  window.location = window.location.origin;
}
